export { default } from './BlogPostView'
